import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import imgBrand from '../assets/v_rptbrd.png';
import imgCosti from '../assets/v_ridcosti.png';
import imgMercati from '../assets/v_opfz.png';
import imgRischi from '../assets/v_rischio.png';
import imgTalent from '../assets/v_talent.png';

const cards = [
  {
    accent: '#1D9E75',
    tag: 'Reputazione',
    title: 'Migliore Brand Identity',
    body: "Essere un'azienda software certificata ESG rafforza la tua immagine come leader responsabile e innovativo. Attrai clienti, partner e talenti che condividono i tuoi valori.",
    pills: ['Fiducia', 'Leadership', 'Valori'],
    icon: '◎',
    img: imgBrand,
    wide: false,
  },
  {
    accent: '#378ADD',
    tag: 'Efficienza',
    title: 'Riduzione dei Costi Operativi',
    body: "L'attenzione all'efficienza energetica e all'ottimizzazione delle risorse riduce significativamente i costi operativi per i tuoi data center e le infrastrutture.",
    stats: [{ num: '-30%', label: 'consumi energetici' }, { num: '-20%', label: 'costi infrastruttura' }],
    icon: '\u25C8',
    img: imgCosti,
    wide: false,
  },
  {
    accent: '#D85A30',
    tag: 'Crescita',
    title: 'Accesso a Nuovi Mercati e Finanziamenti',
    body: 'Sempre più investitori e fondi cercano aziende con solide credenziali ESG. Una certificazione ti apre le porte a nuove opportunità di finanziamento e a mercati emergenti sensibili alla sostenibilità.',
    pills: ['Investitori ESG', 'Bandi pubblici', 'Mercati globali'],
    icon: '◐',
    img: imgMercati,
    wide: false,
  },
  {
    accent: '#7F77DD',
    tag: 'Governance',
    title: 'Gestione del Rischio Migliorata',
    body: 'Implementare una governance robusta e pratiche sociali responsabili riduce i rischi legali, reputazionali e operativi, garantendo una maggiore stabilità e resilienza ai tuoi progetti.',
    pills: ['Rischio legale', 'Resilienza', 'Stabilità'],
    icon: '◇',
    img: imgRischi,
    wide: false,
  },
  {
    accent: '#BA7517',
    tag: 'Persone',
    title: 'Attrazione e Retenzione dei Talenti',
    body: "I professionisti di oggi cercano aziende con uno scopo e valori forti. Dimostrare il tuo impegno per l'ESG ti renderà un datore di lavoro più attraente, aiutandoti a reclutare e mantenere i migliori talenti nel settore tecnologico.",
    stats: [
      { num: '+40%', label: 'candidature qualificate' },
      { num: '+25%', label: 'retention a 3 anni' },
      { num: '+18%', label: 'soddisfazione team' },
    ],
    icon: '◉',
    img: imgTalent,
    wide: true,
  },
];

export default function VantaggiESGSection() {
  const navigate = useNavigate();
  const cardRefs = useRef([]);

  useEffect(() => {
    const timers = cardRefs.current.map((el, i) =>
      setTimeout(() => { if (el) el.style.opacity = '1'; if (el) el.style.transform = 'translateY(0)'; }, 100 + i * 100)
    );
    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <section style={{ fontFamily: "'DM Sans', sans-serif", padding: '80px 24px', maxWidth: 1100, margin: '0 auto' }}>

      {/* Intro */}
      <div style={{ textAlign: 'center', marginBottom: 72 }}>
        <h2 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 42, fontWeight: 400, color: '#1a1a1a', lineHeight: 1.2, marginBottom: 20, maxWidth: 640, marginLeft: 'auto', marginRight: 'auto' }}>
          Scopri un nuovo modo per valorizzare i tuoi progetti
        </h2>
        <p style={{ fontSize: 16, color: '#555', lineHeight: 1.7, maxWidth: 580, margin: '0 auto' }}>
          Un software certificato ESG non è solo uno strumento per la conformità normativa, ma un{' '}
          <strong style={{ color: '#1a1a1a', fontWeight: 500 }}>asset strategico</strong>{' '}
          che permette alle aziende di trasformare la sostenibilità in un reale vantaggio competitivo.
        </p>
      </div>

      {/* Cards grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 2, background: '#e0e0e0', borderRadius: 12, overflow: 'hidden' }}>
        {cards.map((card, i) => (
          <div
            key={i}
            ref={el => cardRefs.current[i] = el}
            style={{
              background: '#fff',
              padding: '40px 36px',
              position: 'relative',
              overflow: 'hidden',
              gridColumn: card.wide ? 'span 2' : 'span 1',
              opacity: 0,
              transform: 'translateY(16px)',
              transition: 'opacity 0.5s, transform 0.5s, background 0.2s',
              cursor: 'default',
            }}
            onMouseEnter={e => e.currentTarget.style.background = '#f9f9f7'}
            onMouseLeave={e => e.currentTarget.style.background = '#fff'}
          >
            {/* Accent bar */}
            <div style={{ width: 48, height: 4, borderRadius: 2, background: card.accent, marginBottom: 24 }} />

            {/* Tag */}
            <div style={{ fontSize: 11, letterSpacing: '0.08em', textTransform: 'uppercase', fontWeight: 500, color: '#999', marginBottom: 10 }}>
              {card.tag}
            </div>

            {/* Title */}
            <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 22, fontWeight: 400, color: '#1a1a1a', marginBottom: 14, lineHeight: 1.25 }}>
              {card.title}
            </div>

            {/* Body */}
            <div style={{ fontSize: 14, color: '#666', lineHeight: 1.7, maxWidth: card.wide ? 560 : 'none' }}>
              {card.body}
            </div>

            {/* Pills */}
            {card.pills && (
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 20 }}>
                {card.pills.map(p => (
                  <span key={p} style={{ fontSize: 12, fontWeight: 500, padding: '4px 12px', borderRadius: 20, border: '0.5px solid #ddd', color: '#666', background: '#f5f5f3' }}>
                    {p}
                  </span>
                ))}
              </div>
            )}

            {/* Stats */}
            {card.stats && (
              <div style={{ display: 'flex', gap: 24, marginTop: 20, flexWrap: 'wrap' }}>
                {card.stats.map(s => (
                  <div key={s.label} style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <span style={{ fontFamily: "'DM Serif Display', serif", fontSize: 28, color: '#1a1a1a' }}>{s.num}</span>
                    <span style={{ fontSize: 12, color: '#999' }}>{s.label}</span>
                  </div>
                ))}
              </div>
            )}

            {/* Background icon */}
            {/* <div style={{ position: 'absolute', bottom: 28, right: 28, opacity: 0.07, fontSize: 72, lineHeight: 1, pointerEvents: 'none', userSelect: 'none' }}>
              {card.icon}
            </div> */}
            <div style={{ position: 'absolute', bottom: 28, right: -50, opacity: 0.7 }}>
              <img src={card.img} alt="image card" style={{width:'65%'}} />
            </div>
          </div>
        ))}
      </div>

      {/* CTA */}
      <div style={{ marginTop: 48, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16, flexWrap: 'wrap' }}>
        <button
          onClick={() => navigate('/register')}
          style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 14, fontWeight: 500, padding: '12px 28px', borderRadius: 8, background: '#1D9E75', color: '#fff', border: 'none', cursor: 'pointer' }}
        >
          Inizia la certificazione →
        </button>
        <button
          onClick={() => navigate('/login')}
          style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 14, fontWeight: 500, padding: '12px 28px', borderRadius: 8, background: 'transparent', color: '#1a1a1a', border: '0.5px solid #ccc', cursor: 'pointer' }}
        >
          Accedi al portale
        </button>
      </div>

      {/* Google Fonts */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:wght@300;400;500&display=swap" rel="stylesheet" />
    </section>
  );
}
